import { HomePage } from './pages/HomePage'
import React, { useEffect, useState } from 'react'
import { Route } from 'react-router-dom'
import { Routes } from 'react-router'
import css from './App.module.css'
import { readConfig } from './store/config'
import { login, loginCookie, loginUnregisteredUser } from './store/profile'
import { Language } from './components/Language'
import { useThunkDispatch } from 'hooks'
import * as qs from 'query-string'
import { Logger } from '@lynx/client-core/src/modules'
import '@lynx/client-core/src/index.css'
import { useFetchAvatar } from '@lynx/client-core/src/hooks/useFetchAvatar'
import { AuthComplete, AuthLoginPage } from '@lynx/client-core/src/pages/Auth'

export const App = (): React.ReactElement | null => {
	const dispatchThunk = useThunkDispatch()
	const [configured, setConfigured] = useState(false)
	useFetchAvatar()

	useEffect(() => {
		const mount = async (): Promise<void> => {
			// Read the config from public folder into Config State
			const configRead = await dispatchThunk(readConfig())

			// Retrieve the accessToken and displayName from query parameters
			const query = qs.parse(location.search)
			const { accessToken, displayName } = query

			// Attempt to login via cookie
			const token = await dispatchThunk(loginCookie())
			if (token) {
				Logger.log('Used Token: true')
			}

			// If cookie login failed then use the accessToken
			if (!token) {
				if (accessToken) {
					Logger.log('Used accessToken: true')
					await dispatchThunk(loginUnregisteredUser(`${accessToken}`, `${displayName}`))
				} else {
					Logger.log('Used Session: true')
					// Attempt a session login
					dispatchThunk(login(null))
				}
			}

			setConfigured(configRead)
		}
		mount()
	}, [])

	if (!configured) {
		return null
	}

	return (
		<div className={css['container']}>
			<Language />
			<Routes>
				<Route path="/" element={<HomePage />} />
				<Route path="/auth/login" element={<AuthLoginPage />} />
				<Route path="/auth/complete/*" element={<AuthComplete />} />
			</Routes>
		</div>
	)
}
